/** What the page is, which decides the label, the lede and the rows. */
export enum PublishedPageKind {
  presave = 'presave',
  release = 'release',
  bioLink = 'bioLink',
}
